module.exports = __webpack_public_path__ + "img/wxtip.7520c317.png";